(function () {
  if (window.__mpnFav) return; window.__mpnFav = true;
  var cfgEl = document.getElementById('mpn-fav-cfg');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var LANG = CFG.lang || 'fr';
  var TX = {
    fr: { add: 'Ajouter à mes favoris', rm: 'Retirer de mes favoris', added: 'Ajouté à vos favoris', removed: 'Retiré de vos favoris', see: 'Voir mes favoris', seeS: 'Voir',
          title: 'Mes favoris', sub: 'Les produits que vous avez mis de côté.', empty: 'Aucun favori pour l’instant. Touchez le ♡ sur la photo d’un produit pour le retrouver ici.',
          del: 'Retirer', view: 'VOIR', mail: 'M’envoyer mes favoris par e-mail', copy: 'Copier le lien de partage', copied: 'Lien copié', close: 'Fermer', subj: 'Mes favoris – Minéral',
          from: 'Dès', pc: 'pièce', instock: 'En stock', out: 'Épuisé',
          stl: 'Commander une surface test', q: 'Une question sur votre sélection ?', tel: '03 60 12 33 53', share: 'Partager mes favoris', loading: 'Chargement…' },
    en: { add: 'Add to favourites', rm: 'Remove from favourites', added: 'Added to your favourites', removed: 'Removed from your favourites', see: 'See my favourites', seeS: 'View',
          title: 'My favourites', sub: 'The products you have set aside.', empty: 'No favourites yet. Tap the ♡ on a product photo to save it here.',
          del: 'Remove', view: 'VIEW', mail: 'Email me my favourites', copy: 'Copy the share link', copied: 'Link copied', close: 'Close', subj: 'My favourites – Minéral',
          from: 'From', pc: 'piece', instock: 'In stock', out: 'Sold out',
          stl: 'Order a test area', q: 'A question about your selection?', tel: '+33 3 60 12 33 53', share: 'Share my favourites', loading: 'Loading…' },
    de: { add: 'Zu Favoriten hinzufügen', rm: 'Aus Favoriten entfernen', added: 'Zu Ihren Favoriten hinzugefügt', removed: 'Aus Ihren Favoriten entfernt', see: 'Meine Favoriten ansehen', seeS: 'Ansehen',
          title: 'Meine Favoriten', sub: 'Die Produkte, die Sie sich vorgemerkt haben.', empty: 'Noch keine Favoriten. Tippen Sie auf das ♡ auf einem Produktfoto, um es hier zu speichern.',
          del: 'Entfernen', view: 'ANSEHEN', mail: 'Favoriten per E-Mail an mich senden', copy: 'Link zum Teilen kopieren', copied: 'Link kopiert', close: 'Schließen', subj: 'Meine Favoriten – Minéral',
          from: 'Ab', pc: 'Stück', instock: 'Auf Lager', out: 'Ausverkauft',
          stl: 'Testfläche bestellen', q: 'Fragen zu Ihrer Auswahl?', tel: '06838 979 91 58', telh: '+4968389799158', share: 'Favoriten teilen', loading: 'Wird geladen…' }
  };
  var T = TX[LANG] || TX.fr;
  var LOC = LANG === 'de' ? 'de-DE' : (LANG === 'en' ? 'en-IE' : 'fr-FR');
  var ROOT = CFG.root || '/'; if (ROOT.slice(-1) !== '/') ROOT += '/';
  var KEY = 'mpn_fav_v3';
  var ICO_SQ = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4.5" y="4.5" width="15" height="15" rx="1"/><path d="M4.5 12h15M12 4.5v15"/></svg>';
  var ICO_PHONE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>';
  var ICO_SHARE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.6-4.7-7.6-10.6A4.3 4.3 0 0 1 12 7a4.3 4.3 0 0 1 7.6 2.7c0 5.9-7.6 10.6-7.6 10.6z"/></svg>';

  function load() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function url(h) { return ROOT + 'products/' + encodeURIComponent(h); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function handleOf(href) { var m = String(href || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function money(c) { return (c / 100).toLocaleString(LOC, { style: 'currency', currency: 'EUR' }); }
  function num(n) { return (Math.round(n * 100) / 100).toLocaleString(LOC, { maximumFractionDigits: 2 }); }

  var lastTog = 0;
  function toggle(item) {
    var now = Date.now(); if (now - lastTog < 500) return; lastTog = now;
    var a = load(), i = -1;
    a.forEach(function (x, k) { if (x.h === item.h) i = k; });
    if (i > -1) { a.splice(i, 1); save(a); refresh(); toast(T.removed, false); return; }
    a.unshift(item); save(a); refresh(); toast(T.added, true);
  }

  /* ---------- Clics sur les coeurs : interceptes avant tout le reste de la page (carrousels, liens de carte, zoom) ---------- */
  function favBtn(e) { var t = e.target; return t && t.closest ? t.closest('.mpn-fav-btn--card, .mpn-fav-btn--pdp') : null; }
  ['pointerdown', 'pointerup', 'touchstart', 'touchend', 'mousedown', 'mouseup'].forEach(function (t) {
    window.addEventListener(t, function (e) { if (favBtn(e)) e.stopImmediatePropagation(); }, { capture: true, passive: true });
  });
  window.addEventListener('click', function (e) {
    var b = favBtn(e); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.classList.contains('mpn-fav-btn--pdp')) toggle(pdpItem()); else toggle({ h: b.getAttribute('data-mpn-fav') });
  }, true);

  /* ---------- Fenetre « Prevenez-moi » (appli Back in Stock) : la page derriere ne bouge plus tant qu'elle est ouverte ---------- */
  (function () {
    var RE = /prévenez|prevenez|m'alerter|me prévenir|notify|benachrichtig|quand disponible|when available|wieder verf/i;
    var t = 0, miss = 0, seen = false, end = 0;
    function modal(el) {
      for (var x = el; x && x !== document.body; x = x.parentElement) {
        if (x.getAttribute && x.getAttribute('role') === 'dialog') return true;
        if (getComputedStyle(x).position === 'fixed') return true;
      }
      return false;
    }
    function open() {
      var els = document.querySelectorAll('input[type=email], iframe');
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.width > 40 && r.height > 20 && r.bottom > 0 && r.top < window.innerHeight && !els[i].closest('.mpn-fav-pn') && modal(els[i])) return true;
      }
      return false;
    }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button, a, [role=button], input[type=submit], input[type=button]') : null;
      if (!b || b.closest('.mpn-fav-pn') || !RE.test(b.textContent || b.value || '')) return;
      miss = 0; seen = false; end = Date.now() + 600000;
      document.documentElement.classList.add('mpn-bis-open');
      if (!t) t = setInterval(function () {
        if (open()) { miss = 0; seen = true; } else miss++;
        if (miss >= (seen ? 2 : 10) || Date.now() > end) { document.documentElement.classList.remove('mpn-bis-open'); clearInterval(t); t = 0; }
      }, 700);
    }, true);
  })();

  /* Croix dans les bulles d'info : un toucher n'importe ou dans la bulle la ferme deja (script du theme), la croix le rend evident */
  function tipX() {
    [].forEach.call(document.querySelectorAll('.sample-block__info-content, .product__cuttings-info > span'), function (c) {
      if (c.querySelector('.mpn-tip-x')) return;
      var x = document.createElement('span'); x.className = 'mpn-tip-x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
      if (getComputedStyle(c).position === 'static') c.style.position = 'relative';
      c.classList.add('mpn-has-x'); c.insertBefore(x, c.firstChild);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tipX); else tipX();
  setInterval(tipX, 1500);

  /* ---------- Coeur sur les cartes produit ---------- */
  function decorateCards() {
    document.querySelectorAll('.product-card-wrapper .card__inner').forEach(function (cardInner) {
      var card = cardInner.closest('.product-card-wrapper');
      var li = card && (card.closest('.grid__item, li') || card.parentElement);
      if ((li || card).querySelector('.mpn-fav-btn')) return;
      var link = card.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"], a[href*="/products/"]');
      var h = link ? handleOf(link.getAttribute('href')) : '';
      if (!h) return;
      /* avec photos defilantes : coeur pose sur la case de la grille (fixe pendant le swipe) ; sinon sur la carte entiere
         (pas dans la photo : le lien invisible de la carte passait par-dessus et ouvrait la fiche au lieu du coeur) */
      var host = li || card;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mpn-fav-btn mpn-fav-btn--card'; b.setAttribute('data-mpn-fav', h);
      b.innerHTML = HEART;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(b);
    });
  }

  /* ---------- Coeur sur la fiche produit (sous la loupe) : retient format + quantite ---------- */
  function pdpItem() {
    var form = document.querySelector('.product__info-container form[id^="product-form-"]:not([id*="installment"])') || document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    var idIn = form && form.querySelector('[name="id"]');
    var qIn = (form && (form.querySelector('[name="quantity"]') || (form.id && document.querySelector('[name="quantity"][form="' + form.id + '"]')))) || document.querySelector('.product__info-container .quantity__input');
    var it = { h: CFG.pdp };
    if (idIn && idIn.value) it.v = parseInt(idIn.value, 10);
    if (qIn && parseFloat(qIn.value) > 0) it.q = Math.max(1, Math.round(parseFloat(qIn.value)));
    return it;
  }
  /* Un coeur dans chaque photo, juste sous la loupe, place en CSS exactement comme elle :
     il suit la photo au swipe et passe sous le menu au defilement, comme la loupe. */
  function placePdp() {
    if (!CFG.pdp) return;
    [].forEach.call(document.querySelectorAll('.product__media-wrapper .product__modal-opener'), function (op) {
      if (op.querySelector('.mpn-fav-btn--pdp')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mpn-fav-btn mpn-fav-btn--pdp'; b.setAttribute('data-mpn-fav', CFG.pdp);
      b.innerHTML = HEART;
      op.appendChild(b);
    });
  }

  /* ---------- Coeur dans le menu du haut (seulement si le projet n'est pas vide) ---------- */
  var hdBtn = null;
  function placeHeader() {
    var acc = document.querySelector('.header__icons .header__icon--account');
    var box = acc ? acc.parentNode : document.querySelector('.header__icons');
    if (!box) return;
    if (!hdBtn) {
      hdBtn = document.createElement('a');
      hdBtn.href = '#mon-projet'; hdBtn.className = 'header__icon link focus-inset mpn-fav-hd';
      hdBtn.setAttribute('aria-label', T.title);
      hdBtn.innerHTML = '<span class="svg-wrapper">' + HEART + '</span><span class="mpn-fav-n"></span>';
      hdBtn.addEventListener('click', function (e) { e.preventDefault(); openPanel(); });
    }
    if (!box.contains(hdBtn)) box.insertBefore(hdBtn, acc || box.querySelector('.header__icon--cart') || null);
  }

  var lastSig = '';
  function refresh() {
    var a = load(), n = a.length, set = {};
    a.forEach(function (x) { set[x.h] = 1; });
    document.querySelectorAll('[data-mpn-fav]').forEach(function (b) {
      var on = !!set[b.getAttribute('data-mpn-fav')];
      if (b.classList.contains('is-on') === on && b.hasAttribute('aria-pressed')) return;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? T.rm : T.add);
    });
    if (hdBtn) { hdBtn.hidden = n === 0; hdBtn.querySelector('.mpn-fav-n').textContent = n > 99 ? '99+' : String(n); }
    if (pn && pn.classList.contains('is-on') && a.map(function (x) { return x.h; }).join('|') !== lastSig) renderList();
  }

  /* ---------- Message ---------- */
  var tEl = null, tT = 0;
  function toast(msg, withLink) {
    if (!tEl) { tEl = document.createElement('div'); tEl.className = 'mpn-fav-toast'; tEl.setAttribute('role', 'status'); document.body.appendChild(tEl); }
    tEl.innerHTML = (withLink ? '<span class="mpn-fav-toast__i">' + HEART + '</span>' : '') + '<span class="mpn-fav-toast__m">' + esc(msg) + '</span>' + (withLink ? '<button type="button">' + esc(T.seeS) + '</button>' : '');
    var b = tEl.querySelector('button'); if (b) b.addEventListener('click', function () { tEl.classList.remove('is-on'); openPanel(); });
    tEl.classList.add('is-on'); clearTimeout(tT); tT = setTimeout(function () { tEl.classList.remove('is-on'); }, 3000);
  }

  /* ---------- Donnees produit (vue technique ?view=mpnfav) ---------- */
  var cache = {};
  function info(h) {
    if (cache[h]) return cache[h];
    try { var c = JSON.parse(sessionStorage.getItem('mpn_fav_i3_' + h) || 'null'); if (c && Date.now() - c.ts < 900000) { data[h] = c.d; cache[h] = Promise.resolve(c.d); return cache[h]; } } catch (e) {}
    cache[h] = fetch(url(h) + '?view=mpnfav', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { var d = null; try { d = t ? JSON.parse(t) : null; } catch (e) {} if (d) { data[h] = d; try { sessionStorage.setItem('mpn_fav_i3_' + h, JSON.stringify({ ts: Date.now(), d: d })); } catch (e) {} } return d; })
      .catch(function () { return null; });
    return cache[h];
  }
  function unitOf(v) {
    var pq = parseFloat(String(v.pq || '').replace(',', '.')) || 0;
    var un = String(v.un || '').toLowerCase().replace('m2', 'm²');
    var isArea = /m²|ml/.test(un);
    /* pack : vendu par lots de X m² ; unit : vendu directement au m² (quantite = m²) ; pcs : a la piece */
    return { pq: pq, un: un.indexOf('ml') > -1 ? 'ml' : 'm²', area: pq > 0 && isArea, perUnit: !(pq > 0) && isArea };
  }

  /* ---------- Panneau « Mes favoris » (simple : photo, nom, prix, dispo, Voir) ---------- */
  var ov = null, pn = null, data = {};
  function buildPanel() {
    if (pn) return;
    ov = document.createElement('div'); ov.className = 'mpn-fav-ov';
    pn = document.createElement('aside'); pn.className = 'mpn-fav-pn'; pn.setAttribute('role', 'dialog'); pn.setAttribute('aria-modal', 'true'); pn.setAttribute('aria-label', T.title);
    pn.innerHTML = '<div class="mpn-fav-pn__h"><div><h2></h2><p>' + esc(T.sub) + '</p></div><button type="button" class="mpn-fav-x" aria-label="' + esc(T.close) + '">×</button></div>'
      + '<div class="mpn-fav-pn__b"></div>'
      + '<div class="mpn-fav-pn__f">'
      + '<button type="button" class="mpn-fav-share" data-a="share">' + ICO_SHARE + '<span>' + esc(T.share) + '</span></button>'
      + '<div class="mpn-fav-sh"><button type="button" data-a="mail">' + esc(T.mail) + '</button><button type="button" data-a="copy">' + esc(T.copy) + '</button></div>'
      + '<p class="mpn-fav-tel">' + esc(T.q) + ' <a href="tel:' + (T.telh || '+33360123353') + '">' + ICO_PHONE + '<span>' + esc(T.tel) + '</span></a></p></div>';
    document.body.appendChild(ov); document.body.appendChild(pn);
    ov.addEventListener('click', closePanel);
    pn.querySelector('.mpn-fav-x').addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pn.classList.contains('is-on')) closePanel(); });
    /* Clic en dehors du panneau (page ou voile sombre) : ferme comme la croix. En capture sur window pour passer avant les scripts du theme ; le coeur du header et la bulle « Voir » sont ignores */
    window.addEventListener('click', function (e) { if (!pn.classList.contains('is-on')) return; var t = e.target; if (!t || !t.closest || pn.contains(t) || t.closest('.mpn-fav-hd, .mpn-fav-toast')) return; closePanel(); }, true);
    pn.querySelector('[data-a="share"]').addEventListener('click', function () {
      var link = shareLink();
      if (navigator.share) { navigator.share({ title: T.subj, text: T.subj, url: link }).catch(function () {}); return; }
      pn.querySelector('.mpn-fav-sh').classList.toggle('is-on');
    });
    pn.querySelector('[data-a="mail"]').addEventListener('click', function () {
      location.href = 'mailto:?subject=' + encodeURIComponent(T.subj) + '&body=' + encodeURIComponent(summary());
    });
    pn.querySelector('[data-a="copy"]').addEventListener('click', function () {
      var link = shareLink();
      var done = function () { toast(T.copied, false); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, function () { window.prompt(T.copy, link); });
      else window.prompt(T.copy, link);
    });
  }
  /* En apercu d'un theme non publie, le lien garde l'apercu (sinon il ouvrirait le site en ligne, sans les favoris) */
  function shareLink() {
    var pv = '';
    try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' && Shopify.theme.id) pv = '&preview_theme_id=' + Shopify.theme.id; } catch (e) {}
    return location.origin + ROOT + '?mpn_fav=' + load().map(function (x) { return encodeURIComponent(x.h); }).join(',') + pv;
  }
  /* Prix affiche comme dans les collections : le plus bas au m² (ou ml) si vendu en surface, sinon a la piece ; « Des » s'il y a plusieurs prix */
  function priceOf(d) {
    var vs = d.v.filter(function (v) { return v.a; }); if (!vs.length) vs = d.v;
    var best = null, many = false;
    vs.forEach(function (v) {
      var u = unitOf(v), pm = parseFloat(String(v.pm || '').replace(',', '.')) || 0;
      var val = u.area ? (pm > 0 ? Math.round(pm * 100) : v.p / u.pq) : v.p, lab = (u.area || u.perUnit) ? u.un : T.pc;
      if (best && Math.abs(best.val - val) > 0.5) many = true;
      if (!best || val < best.val) best = { val: val, lab: lab };
    });
    return best ? (many ? T.from + ' ' : '') + money(best.val) + ' / ' + best.lab : '';
  }
  function summary() {
    return load().map(function (x) { var d = data[x.h]; return '- ' + (d ? d.t + (priceOf(d) ? ' (' + priceOf(d) + ')' : '') : x.h) + '\n  ' + location.origin + url(x.h); }).join('\n\n');
  }
  function sel(b, h) { return b.querySelector('.mpn-fav-it[data-h="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]'); }
  function renderList() {
    var a = load(), b = pn.querySelector('.mpn-fav-pn__b');
    lastSig = a.map(function (x) { return x.h; }).join('|');
    pn.querySelector('h2').textContent = T.title + (a.length ? ' (' + a.length + ')' : '');
    pn.querySelector('.mpn-fav-pn__f').hidden = !a.length;
    if (!a.length) { b.innerHTML = '<p class="mpn-fav-empty">' + esc(T.empty) + '</p>'; return; }
    b.innerHTML = a.map(function (x) {
      return '<div class="mpn-fav-it" data-h="' + esc(x.h) + '"><span class="mpn-fav-ph"></span><div><span class="mpn-fav-it__t">' + esc(T.loading) + '</span></div></div>';
    }).join('');
    a.forEach(function (x) {
      if (data[x.h]) { var el = sel(b, x.h); if (el) drawItem(el, x.h); return; }
      info(x.h).then(function (d) { var el = sel(b, x.h); if (el && d) drawItem(el, x.h); });
    });
  }
  function drawItem(el, h) {
    var d = data[h]; if (!d) return;
    var u = d.u || url(h);
    el.innerHTML = (d.i ? '<a href="' + esc(u) + '"><img src="' + esc(d.i) + '" alt="" loading="lazy" width="64" height="64"></a>' : '<span class="mpn-fav-ph"></span>')
      + '<div><a class="mpn-fav-it__t" href="' + esc(u) + '">' + esc(d.t) + '</a>'
      + '<div class="mpn-fav-pr">' + esc(priceOf(d)) + '</div>'
      + '<div class="mpn-fav-ft"><span class="mpn-fav-st' + (d.a ? '' : ' is-out') + '"><i></i>' + esc(d.a ? T.instock : T.out) + '</span>'
      + '<span class="mpn-fav-act"><a class="mpn-fav-it__v" href="' + esc(u) + '">' + esc(T.view) + '</a><button type="button" class="mpn-fav-it__r">' + esc(T.del) + '</button></span></div>'
      + (d.a && d.st ? '<a class="mpn-fav-stl" data-h="' + esc(h) + '" href="' + esc(u) + (u.indexOf('?') > -1 ? '&' : '?') + 'mpn_st=1#mpn-surface-test">' + ICO_SQ + '<span>' + esc(T.stl) + '</span></a>' : '')
      + '</div>'
      + (!d.a && d.alt ? d.alt : '');
    var stl = el.querySelector('.mpn-fav-stl');
    if (stl) stl.addEventListener('click', function (e) {
      try { sessionStorage.setItem('mpn_st_go', h + '|' + Date.now()); } catch (er) {}
      if (stl.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return;
      e.preventDefault(); closePanel(); goSt(true);
    });
    el.querySelector('.mpn-fav-it__r').addEventListener('click', function () { save(load().filter(function (y) { return y.h !== h; })); refresh(); renderList(); });
  }
  /* Arrivee depuis « Commander une surface test » : on descend jusqu'a l'encart surface test de la fiche et on l'eclaire un instant */
  function goSt(now) {
    var flag = false;
    try { var f = (sessionStorage.getItem('mpn_st_go') || '').split('|'); if (f[0] && f[0] === CFG.pdp && Date.now() - (+f[1] || 0) < 120000) flag = true; sessionStorage.removeItem('mpn_st_go'); } catch (e) {}
    var asked = location.hash === '#mpn-surface-test' || /[?&]mpn_st=1/.test(location.search);
    if (!now && !flag && !asked) return;
    if (!CFG.pdp) return;
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    try { if (asked) history.replaceState(null, '', location.pathname + location.search.replace(/([?&])mpn_st=1&?/, '$1').replace(/[?&]$/, '')); } catch (e) {}
    var stop = false, flashed = false, tries = 0;
    function quit() { stop = true; }
    ['wheel', 'touchmove', 'keydown'].forEach(function (t) { window.addEventListener(t, quit, { passive: true, once: true }); });
    function box() {
      /* encart surface test de la fiche (.mpn-try, depuis oct. 2026), sinon ancien bloc échantillon */
      return [].filter.call(document.querySelectorAll('.mpn-try, sample-button.sample-block, .sample-block'), function (x) {
        var r = x.getBoundingClientRect(); return !x.hidden && r.height > 0 && r.width > 0;
      })[0];
    }
    /* la page continue de bouger pendant le chargement (photos, blocs) : on se recale plusieurs fois */
    function go() {
      if (stop) return;
      var el = box();
      if (!el) {
        if (++tries < 15) { setTimeout(go, 300); return; }
        el = document.querySelector('.product-form__buttons, product-form'); if (!el) return;
      }
      var r = el.getBoundingClientRect();
      var y = window.pageYOffset + r.top - Math.max(80, (window.innerHeight - r.height) / 2);
      window.scrollTo({ top: Math.max(0, y), behavior: (now && !flashed) ? 'smooth' : 'auto' });
      if (!flashed) {
        flashed = true;
        el.classList.remove('mpn-st-flash'); void el.offsetWidth; el.classList.add('mpn-st-flash');
        setTimeout(function () { el.classList.remove('mpn-st-flash'); }, 2400);
      }
    }
    go();
    if (!now) {
      if (document.readyState !== 'complete') window.addEventListener('load', function () { setTimeout(go, 50); }, { once: true });
      [700, 1500, 2600].forEach(function (ms) { setTimeout(go, ms); });
      setTimeout(quit, 3500);
    }
  }
  function openPanel() { buildPanel(); renderList(); ov.classList.add('is-on'); pn.classList.add('is-on'); document.documentElement.style.overflow = 'hidden'; }
  function closePanel() { if (!pn) return; ov.classList.remove('is-on'); pn.classList.remove('is-on'); document.documentElement.style.overflow = ''; }

  /* ---------- Lien de partage : ?mpn_fav=handle[:variante:quantite],... ---------- */
  function importShared() {
    var m = location.search.match(/[?&]mpn_fav=([^&#]*)/);
    if (!m) return;
    var parts = decodeURIComponent(m[1]).split(',').map(clean).filter(Boolean).slice(0, 40);
    var q = location.search.replace(/([?&])mpn_fav=[^&#]*&?/, '$1').replace(/[?&]$/, '');
    try { history.replaceState(null, '', location.pathname + q + location.hash); } catch (e) {}
    var a = load();
    parts.forEach(function (p) {
      var s = p.split(':'), h = s[0];
      if (!h || a.some(function (y) { return y.h === h; })) return;
      var it = { h: h }; if (s[1]) it.v = parseInt(s[1], 10); if (s[2]) it.q = parseInt(s[2], 10);
      a.push(it);
    });
    save(a); refresh(); openPanel();
  }

  var warmed = '';
  function warm() { var sig = load().map(function (x) { return x.h; }).join('|'); if (sig === warmed) return; warmed = sig; load().forEach(function (x) { info(x.h); }); }
  function run() { placeHeader(); decorateCards(); placePdp(); refresh(); if (warmed !== load().map(function (x) { return x.h; }).join('|')) (window.requestIdleCallback || setTimeout)(warm, 1500); }
  var tm = 0;
  function soon() { clearTimeout(tm); tm = setTimeout(run, 200); }
  function start() {
    run(); importShared(); goSt(false);
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var ad = recs[i].addedNodes;
        for (var j = 0; j < ad.length; j++) {
          var nd = ad[j];
          if (nd.nodeType !== 1) continue;
          if ((nd.matches && nd.matches('.product-card-wrapper, .grid__item, .header__icons, .header__icon--account, .product__modal-opener, media-gallery')) || (nd.querySelector && nd.querySelector('.product-card-wrapper, .header__icon--account'))) { soon(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () { clearTimeout(tm); tm = setTimeout(placePdp, 250); });
    window.addEventListener('load', soon);
    [800, 2000].forEach(function (ms) { setTimeout(soon, ms); });
    window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
